/**
 * Created by rickborst on 26/07/2017.
 */

class Settings {

    /**
     * Constructs the model.
     *
     * @param {Object} data - Settings data.
     */
    constructor (data = {}) {

        this.personal = data.personal || {};
        this.payment = data.payment || {};
        this.devices = data.devices || [];
    }
}

export default Settings;


// WEBPACK FOOTER //
// ./src/js/models/settings.js